// custom hook to check mobile view
import useMediaQuery from '@mui/material/useMediaQuery';

const useIsMobile = (): boolean => {
  return useMediaQuery('(max-width:1023px)');
};

export default useIsMobile;
